// src/services/api/systemsApi.js
import { rootApi } from './rootApi';
import { formatSystem } from '../../utils/systems/systemUtils';

export const systemsApi = rootApi.injectEndpoints({
    endpoints: (build) => ({
        getPublicSystems: build.query({
            query: ({ sport, lastId }) => ({
                url: 'systems/public',
                params: lastId ? { sport, lastId } : { sport },
            }),
            transformResponse: (response) => {
                return response.map(system => formatSystem(system));
            },
            keepUnusedDataFor: 3600,
            providesTags: (result, error, arg) => [{ type: 'Systems', id: `PUBLIC_${arg.sport.toUpperCase()}` }],
        }),
        getUserSystems: build.query({
            query: () => ({
                url: 'systems/get',
            }),
            transformResponse: (response) => {
                response.private = response.private.map(system => formatSystem(system));
                if(Object.keys(response.followed).length > 0){
                    for(const key in response.followed){
                        response.followed[key] = response.followed[key].map(system=>{
                            const formatted = formatSystem(system);
                            return formatted;
                        });
                    };
                };
                return response;
            },
            keepUnusedDataFor: 3600,
            providesTags: () => [{ type: 'Systems', id: 'USER_SYSTEMS' }],
        }),
        getUpcomingMatches: build.mutation({
            query: (ids) => ({
                url: 'systems/upcoming_matches',
                method: 'POST',
                body: { ids },
            }),
            // Cache for 1 hour (3600 seconds)
            keepUnusedDataFor: 3600,
            providesTags: () => [{ type: 'Systems', id: 'SYSTEM_MATCHES' }],
        }),
        followSystem: build.mutation({
            query: ({ system_id, sport }) => ({
                url: 'systems/follow-system',
                method: 'GET',
                params: { system_id, sport },
            }),
            invalidatesTags: () => [{ type: 'Systems', id: 'USER_SYSTEMS' }],
        }),
        deleteSystem: build.mutation({
            query: (system_id) => ({
                url: `systems/delete?id=${system_id}`,
                method: 'GET',
            }),
            invalidatesTags: () => [{ type: 'Systems', id: 'USER_SYSTEMS' }, {type: 'Systems', id: 'SYSTEM_MATCHES'}],
        }),
        backtestSystem: build.mutation({
            query: (body) => ({
                url: 'gateway/backtest-system',
                method: 'POST',
                body: body,
            }),
        }),
        createSystem: build.mutation({
            query: (body) => ({
                url: 'systems/create',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: () => [{ type: 'Systems', id: 'USER_SYSTEMS' }, {type: 'Systems', id: 'SYSTEM_MATCHES'}],
        }),
        updateSystem: build.mutation({
            query: (body) => ({
                url: 'systems/update',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: () => [{ type: 'Systems', id: 'USER_SYSTEMS' }, {type: 'Systems', id: 'SYSTEM_MATCHES'}],
        }),
        publishSystem: build.mutation({
            query: (system_id) => ({
                url: `systems/publish-system?id=${system_id}`,
                method: 'GET',
            }),
            invalidatesTags: () => [{ type: 'Systems', id: 'USER_SYSTEMS' }, {type: 'Systems', id: 'SYSTEM_MATCHES'}],
        })
    }),
    overrideExisting: false,
});

export const {  
    useGetPublicSystemsQuery,
    useGetUserSystemsQuery,
    useGetUpcomingMatchesMutation,
    useFollowSystemMutation,
    useDeleteSystemMutation,
    useBacktestSystemMutation,
    useCreateSystemMutation,
    useUpdateSystemMutation,
    usePublishSystemMutation,
} = systemsApi;